import { SAVE_SERVICES } from './actionTypes'
import { ServicesType } from './types'
import { ServiceModel } from '../../../types/services/serviceModel'

export const saveServices = (services: ServiceModel): ServicesType => {
	return ({
		type: SAVE_SERVICES,
		payload: services
	})
}
